import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/BTSG60/+types/BTSG60Page";
import { fetchBTSG60PageData } from "@routes/BTSG60/BTSG60Page.server";
import BTSG60PageContent from "@routes/BTSG60/BTSG60PageContent";
import { BTSG60PageContext } from "@routes/BTSG60/utils/types";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /keywords/:keyword route. */
const BTSG60Page = (): React.ReactElement => {
  const context = useLoaderData<BTSG60PageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <BTSG60PageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default BTSG60Page;

export const loader = async () => {
  return await fetchBTSG60PageData();
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as BTSG60PageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as { context?: BTSG60PageContext };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
